/*=========================================================================================
  File Name: moduleUserFile.js
  Description: UserFile Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleUserFileState.js'
import mutations from './moduleUserFileMutations.js'
import actions from './moduleUserFileActions.js'
import getters from './moduleUserFileGetters.js'

export default {
    isRegistered: false,
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}